import React from 'react';
import { List, Filter, Edit, Create, Datagrid, SimpleForm, required,
		TextField, BooleanField, UrlField, DateField, ReferenceField,
		TextInput, BooleanInput, NullableBooleanInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton  } from 'admin-on-rest';

import CHOutgoingLinkField from '../utils/CHOutgoingLinkField'		
import { CardActions, Card, CardText } from 'material-ui/Card';

const hintStyle = {
	fontSize: '11px',
	fontStyle: 'italic',	
	color: '#999',	
	display: 'block',
	marginTop: '3px',
	marginBottom: '5px',	
}


const GridFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Adverteerder" source="user_id" linkType={false} reference="admin/customers" alwaysOn>
            <SelectInput optionText="company_name" />
        </ReferenceInput>
		<ReferenceInput label="Cloudhints site" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains" alwaysOn>
            <SelectInput optionText="title" />
        </ReferenceInput>
		<TextInput source="link_key" label="Link key" alwaysOn />
    </Filter>
);

const GridFiltersDeleted = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Adverteerder" source="user_id" linkType={false} reference="admin/customers" alwaysOn>
            <SelectInput optionText="company_name" />
        </ReferenceInput>
		<ReferenceInput label="Cloudhints site" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains" alwaysOn>
            <SelectInput optionText="title" />
        </ReferenceInput>
		<TextInput source="link_key" label="Link key" alwaysOn />
		<NullableBooleanInput label="Active?" source="linkactive" alwaysOn/>
    </Filter>
);



export const OutgoinglinksList = (props) => (
	<List title="Cloudhints - outgoing links"  perPage={50} filters={<GridFilters />} {...props}>
        <Datagrid >
            <TextField source="link_url" sortable={false} />
            <TextField source="link_description" sortable={false} />
            <TextField source="website_url" sortable={false} />
            <TextField source="link_key" sortable={false} />
			<CHOutgoingLinkField source="outgoing use" sortable={false} />
        	<EditButton />
			<DeleteButton />
		</Datagrid>
    </List>
);

export const OutgoinglinksListDeleted = (props) => (
	<div>
		<Card>
			<CardText>
				<div>
				Hier worden zowel verwijderde (inactive) links getoond, als links die niet meer gebruikt kunnen worden doordat de adverteerder of advertentie is verwijderd. 
				</div>
			</CardText>
		</Card>
		<div>&nbsp;</div>
		<List title="Cloudhints - outgoing links"  perPage={50} filters={<GridFiltersDeleted />} {...props}>
			<Datagrid >
				<TextField source="link_url" sortable={false} />
				<TextField source="link_description" sortable={false} />
				<TextField source="website_url" sortable={false} />
				<TextField source="link_key" sortable={false} />
				<TextField source="advertisement_id" sortable={false} />
				<BooleanField source="linkactive" label="Active?" sortable={false} />
				<CHOutgoingLinkField source="outgoing use" sortable={false} />
				<EditButton />
				<DeleteButton />
			</Datagrid>
		</List>
	</div>
);

export const OutgoinglinksCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
			<TextInput source="link_url" />
            <TextInput source="link_description" />
		  	<ReferenceInput linkType={false} label="Website" source="cloudhintsdomains_id" allowEmpty reference="admin/cloudhintsdomains">
                <SelectInput optionText="title" />
            </ReferenceInput>	
			<ReferenceInput linkType={false} label="Customer" source="user_id" allowEmpty reference="admin/customers">
                <SelectInput optionText="company_name" />
            </ReferenceInput>			
        </SimpleForm>
    </Create>
);

export const OutgoinglinksEdit = (props) => (
    <Edit title="Edit" {...props}>
        <SimpleForm>
           <DisabledInput source="link_key" />
			<BooleanInput source="linkactive" />
			<TextInput source="link_url" />
            <TextInput source="link_description" />
		  	<ReferenceInput label="Domain" source="cloudhintsdomains_id" reference="admin/cloudhintsdomains">
                <SelectInput optionText="title" />
            </ReferenceInput>
			<ReferenceInput linkType={false} label="Customer" source="user_id" allowEmpty reference="admin/customers">
                <SelectInput optionText="company_name" />
            </ReferenceInput>	
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/customers/Outgoinglinks.js